import { createRouter, createWebHashHistory } from 'vue-router'
import { Storage } from '@/utils/util'
import businessRouter from './businessRouter'
import { useKeepAliveStore } from '@/store/keep-alive'
import { getToken } from '@/utils/auth'
import { showDialog } from '@nutui/nutui'

const whiteList = ['/login', '/reset-password'];
const baseRouter = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'login'
    },
    component: () => import('@/pages/login/index')
  }, {
    path: '/check',
    name: "check",
    meta: {
      title: "check"
    },
    component: () => import("@/pages/check/index")
  }, {
    path: '/reset-password',
    name: "reset-password",
    meta: {
      title: "reset-password"
    },
    component: () => import("@/pages/login/reset-password")
  }, {
    path: '/profile',
    name: "profile",
    meta: {
      title: "profile"
    },
    component: () => import("@/pages/profile/index")
  },
  
]

export const router = createRouter({
  mode: 'hash',
  history: createWebHashHistory(import.meta.env.VITE_APP_ROUTER_PATH),
  routes: [...baseRouter, ...businessRouter]
})

router.beforeEach(async (to, from, next) => {
  const token = getToken();
  if (token) {
    next();
  } else {
    const isWhitePath = whiteList.includes(to.path);
    if (isWhitePath) {
      next();
    } else {
      next({ path: '/login' });
    }
  }
});

router.afterEach((to, from, next) => {
  // keepAlive 表示该页面要缓存，keepAliveDeep 表示该页面是缓存页面的下级页面且该页面也需要缓存
  // subAlive 表示是由缓存的页面跳转过来的页面的：不用清空缓存页面列表，否则缓存的页面将失效
  const { title, keepAlive, name, keepAliveDeep, subAlive } = to.meta
  document.title = title
  const keepAliveStore = useKeepAliveStore()
  if (keepAlive && name) {
    if (keepAliveDeep) {
      keepAliveStore.add(name)
    } else {
      keepAliveStore.replace(name)
    }
  } else {
    if (!subAlive) {
      keepAliveStore.clear()
    }
    window.scrollTo(0, 0)
  }
})
function fun(nodes = [], arr = []) {
  for (let item of nodes) {
    arr.push(item)
    if (item.children && item.children.length) {
      fun(item.children, arr)
    }
  }
  return arr
}

// 检查服务端是否已经更新，如果更新刷新页面
const checkAppNewVersion = async () => {
  const url = `/version.json?t=${Date.now()}`
  let res = null
  try {
    res = await fetch(url)
    if (!res.ok) throw new Error('Network response was not ok')
    res = await res.json()
  } catch (err) {
    console.error('checkAppNewVersion error: ', err)
  }
  if (!res) return false // 如果没有响应，返回 false，不进行刷新
  const version = res.version
  const localVersion = Storage.getLoc('APP_VERSION')
  if (localVersion && localVersion !== version) {
    Storage.setLoc({
      key: 'APP_VERSION',
      value: version
    })
    window.location.reload()
    // showDialog({
    //   title: '提示',
    //   content: '检测到新版本，请点击更新',
    //   okText: '更新',
    //   noCancelBtn: true,
    //   onOk: () => {
    //     window.location.reload()
    //   }
    // })
    return true // 返回 true，表示检测到更新
  }
  Storage.setLoc({
    key: 'APP_VERSION',
    value: version
  })
  return false // 返回 false，表示没有更新
}

